import { defineMessages } from 'react-intl';

export default defineMessages({
    affiliationDetials: {
        id: 'ml.quoteandbind.affiliation.Affiliation Details',
        defaultMessage: 'Affiliation Details'
    },
    searchAlert: {
        id: 'ml.quoteandbind.affiliation.searchAlert',
        defaultMessage: 'There may be multiple options for your listed Employer/Affiliation. Please click SEARCH and choose the appropriate match for your situation.'
    },
     futureEffectiveDateError: {
        id: 'ml.quoteandbind.affiliation.futureEffectiveDateError',
        defaultMessage: 'Per Group Account, Effective Date must be on or after {newBusinessEffectiveDate}. Update on Customer Details Tab.'
    },
    baseWizardMessageNonRenters: {
        id: 'ml.quoteandbind.affiliation.wizardMessagePa',
        defaultMessage: 'We’ll find your {boldText} next'
    },
    driversAndVehicles: {
        id: 'ml.quoteandbind.affiliation.driversAndVehicles',
        defaultMessage: 'drivers and vehicles'
    },
    propertyDetails : {
        id: 'ml.quoteandbind.affiliation.propertyDetails',
        defaultMessage: 'property details'
    },
    affiliationHeader: {
        id: 'ml.quoteandbind.affiliation.affiliationHeader',
        defaultMessage: 'Tell us about your employer or affiliation'
    },
    additionalCarrierButtonLabel: {
        id: 'ml.quoteandbind.affiliation.additionalCarrierButtonLabel',
        defaultMessage: 'Additional Carriers'
    },
    policyInfo: {
        id: 'ml.quoteandbind.affiliation.policyInfo',
        defaultMessage: 'policy info'
    },
    discounts: {
        id: 'ml.quoteandbind.affiliation.discounts',
        defaultMessage: 'discounts'
    },
    groupDiscounts: {
        id: 'ml.quoteandbind.affiliation.groupDiscounts',
        defaultMessage: 'Group Discounts'
    },
    gpaSectionHeader: {
        id: 'ml.quoteandbind.affiliation.gpaSectionHeader',
        defaultMessage: 'Employer or Affiliation'
    },
    somethingWentWrong: {
        id: 'ml.quoteandbind.affiliation.Please try again.',
        defaultMessage: 'Something went wrong during this process.Please try again.'
    },
    gcsDirectChannelErrorMsg:{
        id:'ml.quoteandBind.affiliation.gcsDirectChannelErrorMsg',
        defaultMessage:'Group Affiliation is required in A360. Retail business is no longer able to be quoted/sold within FWS'
    },
    employerGpcErrorMsg:{
        id:'ml.quoteandBind.affiliation.employerGpcErrorMsg',
        defaultMessage:'Group Affiliation is required for Mercer Agent. Please Enter Valid Employer / Affiliation / GPC Paypoint Details to Proceed further'
    },
    qnbNonServicingStatesSkipDiscount: {
         id:'ml.quoteandBind.affiliation.qnbNonServicingStatesSkipDiscount',
          defaultMessage:'Skip this discount'     
    } 
});
